"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetadataLoader = void 0;
class MetadataLoader {
  constructor(client, cache) {
    this.client = client;
    this.cache = cache;
  }
  loadMetadata(uri) {
    return this.cache.withCache(uri, async () => {
      let url;
      if (uri.startsWith("ipfs://")) {
        url = "https://gateway.ipfs.io/ipfs/" + uri.slice(7);
      } else {
        url = uri;
      }
      return (await this.client.get(url)).data;
    }, uri);
  }
}
exports.MetadataLoader = MetadataLoader;
//# sourceMappingURL=MetadataLoader.js.map